import { KeyOutlined } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import {
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
} from "../../components/ListDetailView";
import { useUserInfo } from "../../utils/security";

export const EstimatesDetail = ({
    data,
    loading,
    onAddTransaction,
    onShowRecurringDialog,
    onBack,
    ...others
}) => {
    const { userInfo, hasRight } = useUserInfo();
    console.log("data", data);

    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                onBack={onBack}
                title={data?.name}
                titleLoading={loading}
                loading={loading}
                role="overview"
                actions={
                    [
                        /*
                    {
                        title: "Nastavit oprávnění...",
                        icon: <KeyOutlined />,
                        onClick: onShowRecurringDialog,
                    },
                */
                    ]
                }
            />
            <ListDetailViewSectionContent>
                {/*<PeriodField />*/}
                <Container maxWidth="xl">
                    <Box sx={{ py: 4 }}></Box>
                </Container>
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
